import { render, staticRenderFns } from "./ViewerInsertPictogramsModal.vue?vue&type=template&id=3f643b6a&scoped=true"
import script from "./ViewerInsertPictogramsModal.vue?vue&type=script&lang=js"
export * from "./ViewerInsertPictogramsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewerInsertPictogramsModal.vue?vue&type=style&index=0&id=3f643b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f643b6a",
  null
  
)

export default component.exports